import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import api from '../api.js';

export default function AddStory() {
  const navigate = useNavigate();
  const loc = useLocation();
  const { user } = useAuth();
  // Passing `{ state: { sessionCode } }` from EndGame links the story
  // to the round that was just finished.
  const linkedSessionCode = loc.state?.sessionCode || null;
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [caption, setCaption] = useState('');
  const [location, setLocation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const post = async () => {
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      const fd = new FormData();
      fd.append('image', file);
      fd.append('userId', user.uid);
      fd.append('caption', caption);
      fd.append('location', location);
      if (linkedSessionCode) fd.append('gameSessionCode', linkedSessionCode);
      await api.postStory(fd);
      navigate('/community');
    } catch (err) {
      setError(err.message || 'Upload failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <button className="back-btn" onClick={() => navigate(-1)}>←</button>
        <h1>New Story</h1>
        <div className="spacer" />
      </div>

      {linkedSessionCode && (
        <div className="card" style={{ marginBottom: '1rem', textAlign: 'center', fontSize: '0.85rem' }}>
          ⛳ Linked to round <strong>{linkedSessionCode}</strong>
        </div>
      )}

      <label
        className="card"
        style={{
          minHeight: 240,
          display: 'grid',
          placeItems: 'center',
          marginBottom: '1rem',
          cursor: 'pointer',
          overflow: 'hidden',
        }}
      >
        {preview ? (
          <img src={preview} alt="" style={{ maxHeight: 240 }} />
        ) : (
          <div className="text-center text-muted">
            <div style={{ fontSize: '2rem' }}>📷</div>
            <div>Tap to choose a photo</div>
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          capture="environment"
          hidden
          onChange={onFile}
        />
      </label>

      <div className="field">
        <label className="field-label">Caption</label>
        <input
          className="input"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          placeholder="Say something…"
        />
      </div>

      <div className="field">
        <label className="field-label">Location</label>
        <input
          className="input"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Where are you?"
        />
      </div>

      {error && <div className="text-center" style={{ color: 'var(--danger)' }}>{error}</div>}

      <button
        className="btn btn-primary btn-block btn-lg"
        onClick={post}
        disabled={!file || busy}
        style={{ marginTop: '1rem' }}
      >
        {busy ? 'Posting…' : 'Post Story'}
      </button>
    </div>
  );
}
